export const COOKIE_CONSENT_STORAGE_KEY = 'yk_cookie_consent';
export const COOKIE_CONSENT_EVENT = 'yk-cookie-consent-change';
export const COOKIE_PREFERENCES_OPEN_EVENT = 'yk-open-cookie-preferences';

const DEFAULT_CONSENT = Object.freeze({
  necessary: true,
  analytics: false,
  status: 'pending',
  updatedAt: null,
});

function normalizeCookieConsent(value) {
  const status =
    value?.status === 'accepted' || value?.status === 'rejected' || value?.status === 'customized'
      ? value.status
      : 'pending';

  return {
    necessary: true,
    analytics: status === 'accepted' ? true : value?.analytics === true,
    status,
    updatedAt: typeof value?.updatedAt === 'string' ? value.updatedAt : null,
  };
}

export function getCookieConsent() {
  if (typeof window === 'undefined') return DEFAULT_CONSENT;

  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return DEFAULT_CONSENT;
    return normalizeCookieConsent(JSON.parse(raw));
  } catch {
    return DEFAULT_CONSENT;
  }
}

export function hasSavedCookieConsent(consent = getCookieConsent()) {
  return consent.status !== 'pending';
}

export function saveCookieConsent({ analytics, status }) {
  if (typeof window === 'undefined') return DEFAULT_CONSENT;

  const nextConsent = normalizeCookieConsent({
    analytics,
    status,
    updatedAt: new Date().toISOString(),
  });

  window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(nextConsent));
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: nextConsent }));

  return nextConsent;
}

export function openCookiePreferences() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(COOKIE_PREFERENCES_OPEN_EVENT));
}